import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const ArrowIcon = ({ color, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      d="M12.008 7.316c0-.15-.05-.302-.15-.429L6.522.255a.684.684 0 0 0-1.066 0L.151 6.86a.684.684 0 0 0 1.065.856l4.773-5.94 4.803 5.97a.684.684 0 0 0 1.216-.43z"
    />
  </svg>
);

ArrowIcon.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

ArrowIcon.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(12, 8),
};

export default ArrowIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/arrow.js